import { render } from "./FooterPage.vue?vue&type=template&id=afd50eb2&scoped=true"
const script = {}

import "./FooterPage.vue?vue&type=style&index=0&id=afd50eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd50eb2"]])

export default __exports__